import TableContainer from "components/tables/TableContainer"
import React, { useEffect, useMemo, useState } from "react"
import ModalDetailOrder from "./ModalDetailOrder"
import SButton from "components/Common/Button"
import RtwInventoryAPI from "helpers/rtw-inventory_backend_helper"

const TableRetailList = ({
  content,
  onEdit,
  page,
  size,
  count,
  setSize,
  setPage,
}) => {
  const [isModal, setIsModal] = useState(false)
  const [grandTotal, setGrandTotal] = useState(0)

  const fetchGrandTotal = async () => {
    const res = await RtwInventoryAPI.getGrandTotal()

    setGrandTotal(res.data.totalAmount)
  }

  useEffect(() => {
    fetchGrandTotal()
  }, [])

  const columns = useMemo(
    () => [
      {
        Header: "受注日",
        accessor: "orderDate",
        Footer: info => {
          const total = React.useMemo(
            () =>
              info.rows.reduce((sum, row) => row.values.totalAmount + sum, 0),
            [info.rows]
          )
          return (
            <>
              <tr>
                <td></td>
                <td>小計</td>
                <td>{total.toLocaleString("ja-JP")}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td>総合計</td>
                <td>{grandTotal.toLocaleString("ja-JP")}</td>
                <td></td>
                <td></td>
              </tr>
            </>
          )
        },
      },
      {
        Header: "顧客名",
        accessor: "customerName",
        Footer: () => {
          return <tr className="d-none"></tr>
        },
      },
      {
        Header: "金額",
        accessor: "totalAmount",
        Cell: cell => {
          return <>{cell?.row?.original?.totalAmount.toLocaleString("ja-JP")}</>
        },
        Footer: () => {
          return <tr className="d-none"></tr>
        },
      },
      {
        Header: "数",
        accessor: "totalNumber",
        Footer: () => {
          return <tr className="d-none"></tr>
        },
      },
      {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        Footer: () => {
          return <tr className="d-none"></tr>
        },
        Cell: row => {
          return (
            <SButton className="button" onClick={() => onEdit(row)}>
              詳細
            </SButton>
          )
        },
      },
    ],
    [grandTotal]
  )

  const listDataTable = useMemo(() => {
    if (!content) return []
    return content.map((v, i) => ({
      id: v.id,
      orderDate: v.orderDate,
      customerName: v.customerName,
      totalAmount: Number(v.totalAmount),
      totalNumber: v.totalNumber,
      detail: i,
    }))
  }, [content])

  return (
    <>
      <ModalDetailOrder isModal={isModal} setIsModal={setIsModal} />
      <TableContainer
        columns={columns}
        data={listDataTable}
        page={page}
        size={size}
        count={count}
        setPageSize={val => setSize(val)}
        setParams={params => setPage(params.page)}
        pagination
        footer
      />
    </>
  )
}

export default TableRetailList
